/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {FC, useEffect, useState} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {
  TypeClothe,
  Wash,
  SelectModel,
  Reception,
  PointModel,
  SupplierModel,
} from '../../../../../../model'
import {
  getLaundryById,
  getPoint,
  getSupplier,
  updateWashByLaundry,
} from '../../../../../../services'
import {createWashByLaundry} from '../../../../../../services'
import {InputDate, InputText} from '../../../../../../../../components/UI/Input'
import {Select} from '../../../../../../../../components/UI/Select'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'

import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {ModalAddSalida} from '../modal/ModalAddSalida'
import Swal from 'sweetalert2'
import {schemaOrderLaundryWash} from '../../../../../../../../util/validationLavanderia'
import {getMasterService} from '../../../../../../../central/services'
import {ShowSnackBar} from '../../../../../../../../util/functions'
import moment from 'moment'
const TableWash: FC = () => {
  const {data, setData, loading, setLoading} = useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [showModalNew, setShowModalNew] = useState(false)
  const [idPermission, setIdPermission] = useState<any>('')
  const [idWash, setIdWash] = useState<any>(null)
  const [initWash, setInithWash] = useState<boolean>(false)
  const [finishWash, setFinishWash] = useState<boolean>(false)
  const [minLength, setMinLength] = useState<string>('')
  const [detailpermission, setDetailPermission] = useState<TypeClothe | any>(null)
  const methods = useForm<Wash>({
    resolver: yupResolver(schemaOrderLaundryWash),
  })
  const [typeFurniture, setTypeFurniture] = useState<Reception[] | any>([])
  const [point, setPoint] = useState<SelectModel[]>([])
  const [supplier, setSupplier] = useState<SelectModel[]>([])
  const [bolsaCorrelativo, setBolsaCorrelativo] = useState<string>('')
  const [rotuladoCorrelativo, setRotuladoCorrelativo] = useState<string>('')

  const {
    control,
    setValue,
    handleSubmit,
    setError,
    watch,
    register,
    formState: {errors},
  } = methods

  const handleClear = () => {
    setIdPermission('')
  }
  const getLaundryByIdListType = async () => {
    const response = await getLaundryById(currentTabItem.idToEdit)
    const data = response.data.data

    let addIdData = data.detalle?.map((item, index) => {
      return {idRopa: index + 1, ...item}
    })
    setData(addIdData)
    let countTotal =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.cantidad, 0) ||
      0
    let sumWeight =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.peso, 0) || 0
    // setIdWash(data.recepcion.id)
    setValue('pesoTotal', sumWeight)
    setValue('cantidadTotal', countTotal)
  }

  const getLaundryByIdList = async () => {
    const response = await getLaundryById(currentTabItem.idToEdit)
    const data = response.data.data
    setBolsaCorrelativo(data.bolsaCorrelativo)
    setRotuladoCorrelativo(data.rotuladoCorrelativo)
    setLoading(false)
    setValue('nroOrdenLoteLavado', data.nroOrdenLoteLavado)
    getPointList(data.siteId, data.companiaId, data.clienteId, data.campamentoId)
    let addIdData = data.detalle?.map((item, index) => {
      return {idRopa: index + 1, ...item}
    })
    setData(addIdData)
    let countTotal =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.cantidad, 0) ||
      0
    let sumWeight =
      data.detalle?.reduce((acumulador: any, elemento: any) => acumulador + elemento.peso, 0) || 0
    setValue('pesoTotal', sumWeight)
    setValue('cantidadTotal', countTotal)
    console.log(data)
    let punto = data.procesoLavado.puntoId ? data.procesoLavado.puntoId : data.puntoId

    setValue('puntoId', punto)
    let lugarRecep = data.procesoLavado.lugarLavado ? data.procesoLavado.lugarLavado : ''
    setValue('lugarLavado', lugarRecep)
    let proveedor = data.procesoLavado.proveedorId
      ? data.procesoLavado.proveedorId
      : data.proveedorId
    setValue('proveedorId', proveedor || '')

    const fechaRealLavado = data.procesoLavado.fechaRealLavado
      ? new Date(data.procesoLavado.fechaRealLavado)
      : null
    const formattedDate = fechaRealLavado
      ? fechaRealLavado.toISOString().slice(0, 10)
      : moment().format('YYYY-MM-DD')
    setValue('fechaRealLavado', formattedDate)
    const fechaLocalRealSalida = data.procesoLavado.fechaRealSalida
      ? new Date(data.procesoLavado.fechaRealSalida)
      : null
    const formattedDateRealSalida = fechaLocalRealSalida
      ? fechaLocalRealSalida.toISOString().slice(0, 10)
      : ''

    setValue('fechaRealSalida', formattedDateRealSalida)
    const fechaEntregaProveedor = data.procesoLavado.fechaEntregaProveedor
      ? new Date(data.procesoLavado.fechaEntregaProveedor)
      : null
    const formattedDatefechaEntregaProveedor = fechaEntregaProveedor
      ? fechaEntregaProveedor.toISOString().slice(0, 10)
      : ''
    setValue('fechaEntregaProveedor', formattedDatefechaEntregaProveedor)
    const fechaProgramadaProveedor = data.procesoLavado.fechaProgramadaProveedor
      ? new Date(data.procesoLavado.fechaProgramadaProveedor)
      : null
    const formattedDatefechaProgramadaProveedor = fechaProgramadaProveedor
      ? fechaProgramadaProveedor.toISOString().slice(0, 10)
      : ''
    setValue('fechaProgramadaProveedor', formattedDatefechaProgramadaProveedor)
    const fechaDevolucionReal = data.procesoLavado.fechaDevolucionReal
      ? new Date(data.procesoLavado.fechaDevolucionReal)
      : null
    const formattedDatefechaDevolucionReal = fechaDevolucionReal
      ? fechaDevolucionReal.toISOString().slice(0, 10)
      : ''
    setValue('fechaDevolucionReal', formattedDatefechaDevolucionReal)
    let minDate = formattedDate ? formattedDate : formattedDatefechaProgramadaProveedor
    setMinLength(minDate)
    if (data.procesoLavado.fechaRealSalida || data.procesoLavado.fechaDevolucionReal) {
      setFinishWash(true)
    }
    if (data.procesoLavado.id) {
      setIdWash(data.procesoLavado.id)
      setInithWash(true)
    }
  }

  const getPointList = async (
    idSite: string = '',
    idCompany: string = '',
    idClient: string = '',
    idCampamento: string = '',
  ) => {
    let obj: PointModel = {
      isCombo: true,
      siteId: idSite,
      companiaId: idCompany,
      clienteId: idClient,
      campamentoId: idCampamento,
    }
    const response = await getPoint(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.nombre}))
    setPoint(mappedSites)
  }
  const getSupplierList = async () => {
    let obj: SupplierModel = {
      isCombo: true,
    }
    const response = await getSupplier(obj, 1)
    const data = response.data.data
    const mappedSites = data.map((item) => ({value: item.id, label: item.razonSocial}))
    setSupplier(mappedSites)
  }
  const getReceptionPlaceList = async () => {
    try {
      const response = await getMasterService({
        pageNumber: 1,
        size: 100,
        tableName: 'LugarLavadoLavanderia',
      })
      const data = response.data.data || []
      const mappedMaster = data.map((master) => ({
        value: master.codigo.toString(),
        label: master.nombreCorto,
      }))
      setTypeFurniture(mappedMaster)
    } catch (error) {
      console.error('Error al obtener la lista de tipo de documento:', error)
    }
  }

  useEffect(() => {
    getLaundryByIdList()
    getReceptionPlaceList()
    // getPointList()
    getSupplierList()
  }, [])

  const handleEdit = (item: TypeClothe) => {
    const filter = data.filter((detail) => detail.id === item.id)
    setDetailPermission(filter[0])
    setIdPermission(item.id)
    setShowModalNew(true)
  }

  const columns: Column<TypeClothe>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Item' />,
      accessor: 'idRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de ropa' />,
      accessor: 'tipoRopa',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Cantidad' />,
      accessor: 'cantidad',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Peso KG' />,
      accessor: 'peso',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Observaciones' />,
      accessor: 'observaciones',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('PROCESOLAVADO/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.data[props.row.index])}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleGetDateReception = (e: any) => {
    let value = e.target.value
    setMinLength(value)
    setError('fechaRealLavado', {})
  }
  const handleGetDateReceptionSupplier = (e: any) => {
    let value = e.target.value
    setMinLength(value)
    setError('fechaEntregaProveedor', {})
  }
  const handleGetDateDate = (e: any) => {
    setError('fechaRealSalida', {})
  }
  const handleGetDate = (e: any) => {
    setError('fechaDevolucionReal', {})
  }
  const onSubmitReception = async (dataInfo: Wash) => {
    try {
      Swal.fire({
        title: '¿Estás seguro?',
        text: 'Al iniciar el lavado no podrás revertir esta acción',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Si, iniciar',
        confirmButtonColor: 'var(--kt-primary)',
        cancelButtonText: 'No',
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
      }).then(async (result) => {
        /* Read more about isConfirmed, isDenied below */

        if (result.isConfirmed) {
          setLoading(true)
          if (dataInfo.lugarLavado === 'LAVADO EN SITE') {
            delete dataInfo.fechaEntregaProveedor
            delete dataInfo.fechaProgramadaProveedor
            delete dataInfo.proveedorId
          } else {
            delete dataInfo.fechaRealLavado
            delete dataInfo.fechaRealSalida
            delete dataInfo.puntoId
            delete dataInfo.fechaDevolucionReal
          }
          let obj = {
            id: idWash,
            ordenId: currentTabItem.idToEdit,
            lugarLavado: dataInfo.lugarLavado,
            ...dataInfo,
          }
          const {data: response} = await createWashByLaundry(obj)
          if (!response.error) {
            ShowSnackBar('Se registró satisfactoriamente')
            getLaundryByIdList()
          } else {
            ShowSnackBar(response.message, 'error')
          }
          getLaundryByIdList()

          Swal.close()
        } else if (result.isDenied) {
          //Swal.fire('Changes are not saved', '', 'info')
        }
      })
    } catch (error) {}
  }
  const onSubmitFinishWash = async () => {
    try {
      if (watch('fechaRealSalida') || watch('fechaDevolucionReal')) {
        Swal.fire({
          title: '¿Estás seguro?',
          text: 'Al finalizar el lavado no podrás revertir esta acción',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, finalizar',
          confirmButtonColor: 'var(--kt-primary)',
          cancelButtonText: 'No',
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            setLoading(true)
            let obj = {
              id: idWash,
              ...watch(),
            }
            const {data: response} = await updateWashByLaundry(obj)
            if (!response.error) {
              ShowSnackBar('Se registró satisfactoriamente')
              getLaundryByIdList()
            } else {
              ShowSnackBar(response.message, 'error')
            }
            getLaundryByIdList()

            Swal.close()
          } else if (result.isDenied) {
            //Swal.fire('Changes are not saved', '', 'info')
          }
        })
      } else {
        setError('fechaRealSalida', {message: 'La fecha de fin es obligatorio'})
        setError('fechaDevolucionReal', {message: 'La fecha de fin es obligatorio'})
      }
    } catch (error) {}
  }
  const isFinish = currentTabItem.aditionalInformation?.order?.isView
    ? true
    : finishWash
    ? true
    : initWash
    ? false
    : true
  const isDisabled = currentTabItem.aditionalInformation?.order?.isView ? true : finishWash

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='p-2'>
          <FormProvider {...methods}>
            <form>
              {isAllowed('PROCESOLAVADO/INICIAR_LAVADO') && (
                <div className='row'>
                  <div className='mb-2 col-3'>
                    <label className='required'>Lugar de lavado</label>
                    <Select
                      control={control}
                      name='lugarLavado'
                      data={typeFurniture}
                      errors={errors}
                      disabled={isDisabled}
                    />
                  </div>
                  {watch('lugarLavado') === 'LAVADO EN PROVEEDOR' && (
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Proveedor:</label>
                      <Select
                        control={control}
                        name='proveedorId'
                        data={supplier}
                        errors={errors}
                        disabled={isDisabled}
                      />
                    </div>
                  )}
                  {watch('lugarLavado') === 'LAVADO EN SITE' && (
                    <div className='col-sm-12 col-lg-3'>
                      <label className='required'>Lavandería:</label>
                      <Select
                        control={control}
                        name='puntoId'
                        data={point}
                        errors={errors}
                        disabled={isDisabled}
                      />
                    </div>
                  )}
                  {watch('lugarLavado') === 'LAVADO EN SITE' && (
                    <div className='col-sm-12 col-lg-3'>
                      <label>Fecha de inicio real de lavado:</label>
                      <InputDate
                        name='fechaRealLavado'
                        register={register}
                        errors={errors}
                        onChange={handleGetDateReception}
                        disabled={isDisabled}
                      />
                    </div>
                  )}
                  {isAllowed('PROCESOLAVADO/FINALIZAR_LAVADO') &&
                    watch('lugarLavado') === 'LAVADO EN SITE' && (
                      <div className='col-sm-12 col-lg-3'>
                        <label>Fecha fin real de lavado:</label>
                        <InputDate
                          name='fechaRealSalida'
                          register={register}
                          errors={errors}
                          minValue={minLength}
                          onChange={handleGetDateDate}
                          disabled={isFinish}
                        />
                      </div>
                    )}
                  {watch('lugarLavado') === 'LAVADO EN PROVEEDOR' && (
                    <div className='col-sm-12 col-lg-3'>
                      <label>Fecha de entrega a proveedor:</label>
                      <InputDate
                        name='fechaEntregaProveedor'
                        register={register}
                        errors={errors}
                        onChange={handleGetDateReceptionSupplier}
                        disabled={isDisabled}
                      />
                    </div>
                  )}
                  {watch('lugarLavado') === 'LAVADO EN PROVEEDOR' && (
                    <div className='col-sm-12 col-lg-3'>
                      <label>Fecha programada de devolución proveedor:</label>
                      <InputDate
                        name='fechaProgramadaProveedor'
                        register={register}
                        errors={errors}
                        onChange={handleGetDateReception}
                        disabled={isDisabled}
                      />
                    </div>
                  )}
                  {isAllowed('PROCESOLAVADO/FINALIZAR_LAVADO') &&
                    watch('lugarLavado') === 'LAVADO EN PROVEEDOR' && (
                      <div className='col-sm-12 col-lg-3'>
                        <label>Fecha de devolución real de lavado:</label>
                        <InputDate
                          name='fechaDevolucionReal'
                          register={register}
                          errors={errors}
                          minValue={minLength}
                          onChange={handleGetDate}
                          disabled={isFinish}
                        />
                      </div>
                    )}
                </div>
              )}
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label>Cantidad total:</label>
                  <InputText
                    name='cantidadTotal'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Peso total:</label>
                  <InputText name='pesoTotal' register={register} errors={errors} disabled={true} />
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Nro de Lote:</label>
                  <InputText
                    name='nroOrdenLoteLavado'
                    register={register}
                    errors={errors}
                    disabled={true}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-sm-12 col-lg-3'>
                  <label>Codigo de Bolsa:</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      style={{backgroundColor: '#f5f5f5'}}
                      disabled
                      readOnly
                      value={bolsaCorrelativo}
                    />
                  </div>
                </div>
                <div className='col-sm-12 col-lg-3'>
                  <label>Rotulado:</label>
                  <div className='sdx_form_input'>
                    <input
                      type='text'
                      className='form-control sdx-centra-input-form'
                      style={{backgroundColor: '#f5f5f5'}}
                      disabled
                      readOnly
                      value={rotuladoCorrelativo}
                    />
                  </div>
                </div>
              </div>
              <div className='col-sm-12 col-lg-12 d-flex justify-content-end align-items-end'>
                <div className='d-flex justify-content-end'>
                  {isAllowed('PROCESOLAVADO/INICIAR_LAVADO')
                    ? currentTabItem.aditionalInformation?.order?.isView
                      ? true
                      : !initWash && (
                          <button
                            type='button'
                            className='btn btn-primary me-3'
                            disabled={data.length < 1}
                            onClick={handleSubmit(onSubmitReception)}
                          >
                            Iniciar Lavado
                          </button>
                        )
                    : null}
                  {isAllowed('PROCESOLAVADO/FINALIZAR_LAVADO')
                    ? currentTabItem.aditionalInformation?.order?.isView
                      ? true
                      : finishWash
                      ? null
                      : initWash && (
                          <button
                            type='button'
                            className='btn btn-success me-3'
                            onClick={onSubmitFinishWash}
                          >
                            Finalizar Lavado
                          </button>
                        )
                    : null}
                </div>
              </div>
            </form>
          </FormProvider>
        </div>
        {isAllowed('PROCESOLAVADO/LISTAR') && (
          <>
            <KTable data={data} columns={columns} />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}
        <ModalAddSalida
          show={showModalNew}
          setShow={setShowModalNew}
          getReceptionByLaundryList={getLaundryByIdListType}
          detailpermission={detailpermission}
          idPermission={idPermission}
          setIdPermissionList={handleClear}
        />
      </KTCard>
    </>
  )
}

const TableWashWrapper = () => {
  return (
    <KTableProvider>
      <TableWash />
    </KTableProvider>
  )
}
export {TableWashWrapper}
